<div style="padding: 0.5rem;">
    <mat-horizontal-stepper labelPosition="bottom" #stepper (selectionChange)="selectionChange($event)">
        <!-- Set Inprogress Icon -->
        <ng-template matStepperIcon="edit">
            <mat-icon>done</mat-icon>
        </ng-template>.

        <!-- Step 1: Branch creation -->
        <mat-step [editable]="readOnlyBranch" [completed]="false" [state]="getState(branchCreationStatus) || 'number'"
                            (click)="readOnlyBranch && onReleaseStatusClick($event); $event.stopPropagation()"
            (keydown)="noop()">
            <ng-template matStepLabel>
                <span [matTooltip]="toolTipBranchCreationStatus"
                    (mousedown)="$event.stopPropagation()" (keydown)="noop()">
                    Branch Creation
                </span>
            </ng-template>
        </mat-step>
        <!-- Step 2: Release pipeline -->
        <mat-step [editable]="readOnlyManifest" [completed]="false"
            [state]="getState(releasePipelineStatus) || 'number' ">
            <ng-template matStepLabel>
                <span [matTooltip]="toolTipReleasePipelineStatus"
                    (click)="readOnlyManifest && onManifestClick($event); $event.stopPropagation()"
                    (mousedown)="$event.stopPropagation()" (keydown)="noop()">
                    Release Manifest
                </span>
            </ng-template>
        </mat-step>

        <!-- Step 2: Release status -->
        <mat-step [editable]="false" [completed]="false" label="Release status"
            [state]="getState(releaseStatus) || 'number'" style="pointer-events: none;">
            <ng-template matStepLabel>
                <span [matTooltip]="toolTipReleaseStatus">
                    Release status
                </span>
            </ng-template>
        </mat-step>
    </mat-horizontal-stepper>
    </div>
